import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import PopSendMail from '../_PopSendMail';
import BtnLike from "../../../component/Inc/BtnLike";//좋아요 버튼
function ReceivedMail() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <main className="com_container com_mail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_4">받은 메일</h2>
          <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">
            메일 보내기
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <div className="com_btn_wrap center">
                <button className="com_btn black s btn_like active">중요 메일</button>
                <button className="com_btn black s btn_delete_orange">선택 삭제하기</button>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="5%" />
                <col width="12%" />
                <col width="12%" />
                <col width="12%" />
                <col />
                <col width="8%" />
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01"></label>
                  </th>
                  <th></th>
                  <th>보낸 사람</th>
                  <th>받은 날짜</th>
                  <th>메일</th>
                  <th>메일 제목</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>
                    <BtnLike/>
                  </td>
                  <td>
                    <button className="name btn_link">김길동111</button>
                  </td>
                  <td>2023, 05, 11 12:30</td>
                  <td>asdfaaf@naver.com</td>
                  <td>안녕하세요. 금일 일정이 있습니다. 질문있어요!!!안녕하세요. 금일 일정이 있습니다. 질문있어요!!!안녕하세요. 금일 일정이 있습니다. 질문있어요!!!안녕하세요. 금일 일정이 있습니다. 질문있어요!!!안녕하세요. 금일 일정이 있습니다. 질문있어요!!!</td>
                  <td className="td_point">안읽음</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>
                        <input type="checkbox" id={`chk${idx}`} className="com_chk" />
                        <label htmlFor={`chk${idx}`}></label>
                      </td>
                      <td>
                        <BtnLike/>
                      </td>
                      <td>
                        <button className="name btn_link">김길동111</button>
                      </td>
                      <td>2023, 05, 11 12:30</td>
                      <td>asdfaaf@naver.com</td>
                      <td>안녕하세요. 금일 일정이 있습니다. 질문있어요!!!</td>
                      <td>읽음</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
        </section>
      </div>
      <PopSendMail open={modalOpen} close={() => setModalOpen(false)} />
    </main>
  );
}

export default ReceivedMail;
